import enterProcessor from '@/js/mixins/enterProcessor'
import validator from '@/js/mixins/validator'

export default methodName => ({
  mixins: [enterProcessor('submit'), validator],
  data: () => ({
    loading: false,
    keyProcessor: null,
    errorCode: null
  }),
  methods: {
    async submit() {
      this.errorCode = null
      if (!this.isValid()) {
        return
      }

      this.loading = true
      try {
        await this[methodName]()
      } catch (err) {
        this.errorCode = err.code
      }

      this.loading = false
    }
  }
})
